export class DigitalCourseSeller {

  establishmentCode: string;

  vendorEstablishmentCode: string;

  vendorCode: string;

}
